import React from 'react';
import { Alert } from 'antd';
import { Box } from '../../shared/components/basic';


const TokenNoValido = () => (
  <Box p={4}>
    <Alert message={'No puede tener mas de una pestaña abierta en GioWeb'} type="error" />
  </Box>
);

export default TokenNoValido;
